import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DialogRef} from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-pagamentoonline-pedido-retentativa',
  templateUrl: './pagamentoonline-pedido-retentativa.component.html',
  styleUrls: ['./pagamentoonline-pedido-retentativa.component.scss']
})
export class PagamentoonlinePedidoRetentativaComponent {
  @Input() pedido: any;
  @Input() pedidoCarteirasDigitais: any;
  @Input() formaPagamentoCarteirasDigitais: any;
  @Input() exibirCartao = false;
  @Input() exibirCarteirasDigitais = false;
  @Input() exibirPix = false;
  @Input() processando = false;

  @Output() escolheuCartao = new EventEmitter<void>();
  @Output() escolheuPix = new EventEmitter<void>();
  @Output() definiuCarteiraDigital = new EventEmitter<any>();

  constructor(public dialog: DialogRef) { }

  pagueComCartao() {
    if(this.processando) return;
    this.escolheuCartao.emit();
  }

  pagueComPix() {
    if(this.processando) return;
    this.escolheuPix.emit();
  }

  pagueComCarteiraDigital(dadosCartao: any) {
    if(!dadosCartao || this.processando) return;

    this.processando = true;
    this.definiuCarteiraDigital.emit(dadosCartao);
  }

  cancele() {
    if(this.processando) return;
    this.dialog.close();
  }
}
